import React, {useEffect, useState} from 'react';
import {PayPalScriptProvider, PayPalButtons, PayPalCardFieldsProvider, PayPalCardFieldsForm, usePayPalCardFields} from '@paypal/react-paypal-js';
import s from '../../s';
import * as Sentry from '@sentry/react';
import {currency, Portal, getAntiForgeryToken} from '../../../util';

declare var modalOpen: any;
declare var OpenLink: any;
declare var paypal: any;
let set_apple_pay: number = 0;
let apple_pay_loaded: number = 0;
const ppa_debug: boolean = false;
declare var paypal_client_id: string;

const initialOptions = {
    clientId: paypal_client_id,
    currency: 'USD',
    intent: 'capture',
    components: 'card-fields,buttons,applepay,funding-eligibility',
    'enable-funding': 'venmo,paylater',
};

const SubmitPayment = ({isPaying, setIsPaying, billingAddress}) => {
    const {cardFieldsForm, fields} = usePayPalCardFields();

    const handleClick = async () => {
        if (!cardFieldsForm) {
            const childErrorMessage = 'Unable to find any child components in the <PayPalCardFieldsProvider />';

            throw new Error(childErrorMessage);
        }
        const formState = await cardFieldsForm.getState();

        if (!formState.isFormValid) {
            return alert('The payment form is invalid');
        }
        setIsPaying(true);
        s.checkout.messages = [];
        s.uiCheckout.processing = true;

        var ba = {
            addressLine1: s.checkout.billing.addr.address1.value,
            addressLine2: s.checkout.billing.addr.address2.value,
            adminArea1: s.checkout.billing.addr.city.value,
            adminArea2: s.checkout.billing.addr.state.value,
            countryCode: s.checkout.billing.addr.country.value,
            postalCode: s.checkout.billing.addr.postalCode.value,
        };

        // @ts-ignore
        cardFieldsForm.submit({ba}).catch(err => {
            setIsPaying(false);
            s.uiCheckout.processing = false;
            if (ppa_debug) {
                console.log(err);
            }
            if (s.checkout.cstep === ICheckoutStep.payment) {
                s.checkout.messages.push({
                    msg: `Payment Error. Check the credit card number. Details: ${err}`,
                    msgType: ICheckoutMessageType.payment,
                });
            }

            try {
                Sentry.captureException(err);
            } catch (err2) {}
        });
    };

    return (
        <button
            onClick={handleClick}
            style={{
                position: 'relative',
                width: '100%',
                boxSizing: 'border-box',
                verticalAlign: 'top',
                cursor: 'pointer',
                backgroundColor: '#299976',
                color: '#FFF',
                height: '62px',
            }}
        >
            {/* {isPaying ? <div className="spinner tiny" /> : } */}
            <div
                style={{
                    position: 'relative',
                    margin: '0px 4vw',
                    cursor: 'pointer',
                    color: '#FFF',
                    textAlign: 'center',
                    fontSize: '22px',
                }}
            >
                Pay Now
                {s.uiCheckout.processing && (
                    <span className="pad-left">
                        <i className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"></i>
                    </span>
                )}
            </div>
        </button>
    );
};

export default function App() {
    const [appleDisabled, setappleDisabled] = useState(false);
    const [appleLive, setappleLive] = useState(false);
    const [isPaying, setIsPaying] = useState(false);
    const [billingAddress, setBillingAddress] = useState({
        addressLine1: s.checkout.billing.addr.address1.value,
        addressLine2: s.checkout.billing.addr.address2.value,
        adminArea1: s.checkout.billing.addr.city.value,
        adminArea2: s.checkout.billing.addr.state.value,
        countryCode: s.checkout.billing.addr.country.value,
        postalCode: s.checkout.billing.addr.postalCode.value,
    });

    useEffect(() => {
        apple_init();
    });

    function apple_init() {
        if (ppa_debug) {
            console.log('ApplePay: apple_init');
        }

        async function apple_step1() {
            const canShow = showApple();
            try {
                if (paypal == undefined || paypal === 'undefined' || !paypal) {
                    setTimeout(apple_step1, 1000);
                    if (ppa_debug) {
                        console.log('ApplePay: apple_step1_retry 1 sec: paypal missing');
                    }
                    setappleLive(false);
                    return;
                } else if (s.checkout.cstep !== ICheckoutStep.payment) {
                    setTimeout(apple_step1, 1000);
                    // if(ppa_debug){ console.log(`ApplePay: apple_step1_retry 1 sec: checkout step ${s.checkout.cstep}`); }
                    setappleLive(false);
                    return;
                }
            } catch (err) {
                setTimeout(apple_step1, 1000);
                if (ppa_debug) {
                    console.log(`ApplePay: apple_step1_retry 1 sec: ${err}`);
                }
                setappleLive(false);
                return;
            }

            if (ppa_debug) {
                console.log('ApplePay: step 1 -> step 2');
            }

            try {
                if (!window.ApplePaySession || !ApplePaySession) {
                    if (ppa_debug) {
                        console.log('ApplePay: no apple 3');
                    }
                    setappleDisabled(true);
                    setappleLive(false);
                    if (canShow) {
                        setTimeout(apple_step1, 1000);
                    } else {
                        document.getElementById('applepay-outer')?.remove();
                    }
                    return;
                }
            } catch {
                if (ppa_debug) {
                    console.log('ApplePay: no apple 2');
                }
                setappleDisabled(true);
                setappleLive(false);
                if (canShow) {
                    setTimeout(apple_step1, 1000);
                } else {
                    document.getElementById('applepay-outer')?.remove();
                }
                return;
            }
            if (set_apple_pay !== 1 && window.ApplePaySession && ApplePaySession && ApplePaySession?.supportsVersion(4) && ApplePaySession?.canMakePayments()) {
                try {
                    await apple_step2();
                    set_apple_pay = 1;
                } catch (err) {
                    set_apple_pay = 0;
                    if (ppa_debug) {
                        console.log(`ApplePay: apple error 4: ${err}`);
                    }
                    if (canShow) {
                        setTimeout(apple_step1, 1000);
                    } else {
                        document.getElementById('applepay-outer')?.remove();
                    }
                    setappleDisabled(true);
                    setappleLive(false);
                }
            } else {
                if (ppa_debug) {
                    console.log('ApplePay: no apple 5');
                }
                if (canShow) {
                    setTimeout(apple_step1, 1000);
                } else {
                    document.getElementById('applepay-outer')?.remove();
                }
                setappleDisabled(true);
                setappleLive(false);
                return;
            }
        }

        try {
            if (ppa_debug) {
                console.log('ApplePay: apple_step1 first call');
            }
            setappleLive(true);
            apple_step1();
        } catch (err) {
            if (ppa_debug) {
                console.log('ApplePay: error 1234342');
            }
            if (ppa_debug) {
                console.log(err);
            }
        }
    }

    async function apple_step2() {
        const applepay = paypal.Applepay();
        const {isEligible, countryCode, currencyCode, merchantCapabilities, supportedNetworks} = await applepay.config();

        if (!isEligible) {
            if (ppa_debug) {
                console.log('ApplePay: no apple 2');
            }
            setappleDisabled(true);
            return;
        }
        if (ppa_debug) {
            console.log('ApplePay: applepay setup 1');
        }

        let sessionActive: boolean = false;

        async function onClick() {
            if (ppa_debug) {
                console.log({merchantCapabilities, currencyCode, supportedNetworks});
            }
            if (ppa_debug) {
                console.log('ApplePay: onClick');
            }

            // addressLine1: s.checkout.billing.addr.address1.value,
            // addressLine2: s.checkout.billing.addr.address2.value,
            // adminArea1: s.checkout.billing.addr.city.value,
            // adminArea2: s.checkout.billing.addr.state.value,
            // countryCode: s.checkout.billing.addr.country.value,
            // postalCode: s.checkout.billing.addr.postalCode.value,

            var _lines: any[] = [];
            _lines.push({
                label: 'Bag Subtotal',
                type: 'final',
                amount: s.checkout.cart.pricing.subtotal - s.checkout.cart.pricing.discount < 0 ? 0 : (s.checkout.cart.pricing.subtotal - s.checkout.cart.pricing.discount).toFixed(2),
            });
            _lines.push({
                label: 'Shipping',
                type: 'final',
                amount: (s.checkout.cart.pricing.shipping + s.checkout.cart.pricing.production).toFixed(2),
            });
            _lines.push({
                label: 'Tax',
                type: 'final',
                amount: s.checkout.cart.pricing.tax.toFixed(2),
            });

            const paymentRequest = {
                countryCode,
                currencyCode: 'USD',
                merchantCapabilities,
                supportedNetworks,
                requiredBillingContactFields: ['name', 'postalAddress'] as any[],
                requiredShippingContactFields: [],
                billingContact: {
                    givenName: s.checkout.billing.addr.firstName.value,
                    familyName: s.checkout.billing.addr.lastName.value,
                    addressLines: s.checkout.billing.addr.address2.value !== '' ? [s.checkout.billing.addr.address1.value, s.checkout.billing.addr.address2.value] : [s.checkout.billing.addr.address1.value],
                    locality: s.checkout.billing.addr.city.value,
                    postalCode: s.checkout.billing.addr.postalCode.value,
                    administrativeArea: s.checkout.billing.addr.state.value,
                    country: s.checkout.billing.addr.country.value,
                    countryCode: s.checkout.billing.addr.country.value,
                    emailAddress: s.checkout.email.value,
                    phoneNumber: s.checkout.phone.value,
                },
                lineItems: _lines,
                ApplePayShippingType: 'shipping',
                total: {
                    label: Portal?.PortalID === 0 ? 'diplomaframe.com' : Portal?.PortalID === 1 ? 'customframes.com' : 'militaryframes.com',
                    amount: s.checkout.cart.pricing.total.toFixed(2),
                    type: 'final',
                } as any,
            };
            if (ppa_debug) {
                console.log('ApplePay:  paymentRequest');
            }
            if (ppa_debug) {
                console.log(paymentRequest);
            }

            let session = new ApplePaySession(4, paymentRequest);
            if (ppa_debug) {
                console.log('ApplePay:  session');
            }

            if (ppa_debug) {
                console.log('ApplePay:  onClick 1');
            }
            session.onvalidatemerchant = event => {
                applepay
                    .validateMerchant({
                        validationUrl: event.validationURL,
                    })
                    .then(payload => {
                        session.completeMerchantValidation(payload.merchantSession);
                        if (ppa_debug) {
                            console.log('ApplePay:  completeMerchantValidation');
                        }
                    })
                    .catch(err => {
                        // todo debug ?
                        console.error(err);
                        session.abort();
                        sessionActive = false;
                        // alert(err);
                    });
            };

            if (ppa_debug) {
                console.log('ApplePay: onClick 2');
            }
            session.onpaymentmethodselected = () => {
                if (ppa_debug) {
                    console.log('ApplePay: onpaymentmethodselected');
                }
                session.completePaymentMethodSelection({
                    newTotal: paymentRequest.total,
                });
            };

            session.onpaymentauthorized = async event => {
                try {
                    /* Create Order on the Server Side */
                    if (ppa_debug) {
                        console.log('ApplePay: onpaymentauthorized 1');
                    }
                    const orderResponse = await fetch(`/api/pay/create`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            RequestVerificationToken: getAntiForgeryToken(),
                        },
                        body: '',
                    });
                    //   if(!orderResponse.ok) {
                    //       throw new Error("error creating order")
                    //   }

                    if (ppa_debug) {
                        console.log('ApplePay: onpaymentauthorized 2');
                    }

                    var _temp: any = await orderResponse.json();
                    const orderId = _temp.custom_value;
                    if (ppa_debug) {
                        console.log(`ApplePay: onpaymentauthorized 2b: ${orderId}`);
                    }
                    /**
                     * Confirm Payment
                     */
                    await applepay.confirmOrder({
                        orderId: orderId,
                        token: event.payment.token,
                        billingContact: event.payment.billingContact,
                        shippingContact: event.payment.shippingContact,
                    });
                    if (ppa_debug) {
                        console.log('ApplePay: onpaymentauthorized 3');
                    }
                    /*
                     * Capture order (must currently be made on server)
                     */
                    const approveResponse = await fetch(`/api/pay/approve`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            RequestVerificationToken: getAntiForgeryToken(),
                        },
                        body: JSON.stringify({OrderID: orderId}),
                    });
                    //.then(res => console.log(res));

                    session.completePayment({
                        status: window.ApplePaySession.STATUS_SUCCESS,
                    });

                    let r: any = await approveResponse.json();

                    if (ppa_debug) {
                        console.log('ApplePay: onpaymentauthorized 4');
                    }

                    if (!r.isSuccess) {
                        s.uiCheckout.processing = false;
                        s.checkout.messages = [];
                        s.checkout.messages.push({
                            msg: r.errors,
                            msgType: ICheckoutMessageType.payment,
                        });
                        sessionActive = false;

                        if (r.reset_payment === true) {
                            s.reset_payment = true;
                            r.new_checkout_step = 2;
                        }

                        if (r.new_checkout_step > 0) {
                            s.moveStep(r.new_checkout_step);
                            s.checkout.CheckoutType = ICheckoutType.normal;

                            if (r.errors === 'missing-shipping') {
                                s.checkout.force_normal_checkout = true;
                                s.checkout.missing_shipping_info = true;
                                modalOpen('modal-missing-shipping');
                            }
                        }
                    } else {
                        OpenLink(r.custom_url);
                    }
                } catch (err) {
                    // alert(err);
                    console.error(err); // todo debug?
                    session.completePayment({
                        status: window.ApplePaySession.STATUS_FAILURE,
                    });
                    sessionActive = false;
                }
            };

            session.oncancel = () => {
                if (ppa_debug) {
                    console.log('ApplePay: Cancelled');
                }
                sessionActive = false;
            };

            if (sessionActive) {
                return;
            }

            session.begin();
            sessionActive = true;
        }

        if (ppa_debug) {
            console.log('ApplePay: Elements 1');
        }
        (document.getElementById('applepay-container') as HTMLElement).innerHTML = '<apple-pay-button id="btn-appl" buttonstyle="black" type="buy" locale="en" style="width:100%;margin-top:-4px;">';
        document.getElementById('btn-appl')?.addEventListener('click', onClick);
        if (ppa_debug) {
            console.log('ApplePay: Elements 2');
        }
        apple_pay_loaded = 1;
    }

    function showApple(): boolean {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    function createOrder() {
        // console.log('createOrder');
        s.checkout.messages = [];
        return fetch('/api/pay/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                RequestVerificationToken: getAntiForgeryToken(),
            },
            body: '',
        })
            .then(response => response.json())
            .then(order => {
                // console.log(order);
                if (!order.isSuccess) {
                    s.uiCheckout.processing = false;

                    if (order.reset_payment === true && order.custom_msg === 'shipping') {
                        s.checkout.ship.messages.push({
                            msg: order.errors,
                            msgType: ICheckoutMessageType.oci,
                        });
                        s.checkout.messages = [];
                        s.reset_payment = true;
                        s.moveStep(ICheckoutStep.oci);
                        s.checkout.messages = [];
                        return '';
                    } else if (order.reset_payment === true) {
                    } else {
                        s.checkout.messages.push({
                            msg: order.errors,
                            msgType: ICheckoutMessageType.payment,
                        });
                    }

                    throw new Error('Create order did not return an orderId');
                    // return order.custom_value;
                } else if (!order?.custom_value) {
                    throw new Error('Missing order id');
                } else {
                    if (order.custom_url === '/view-order' && order.custom_msg === 'dd') {
                        OpenLink(order.custom_url);
                        return '';
                    } else {
                        // console.log('orderId', order.custom_value);
                        return order.custom_value;
                    }
                }
            })
            .catch(error => {
                console.log(error);
                s.checkout.messages = [];
                if (ppa_debug) {
                    console.log(error);
                }

                if (s.checkout.cstep === ICheckoutStep.payment) {
                    s.checkout.messages.push({
                        msg: 'Payment Error. Check the credit card number.',
                        msgType: ICheckoutMessageType.payment,
                    });
                }
            });
    }

    function onApprove(data) {
        // console.log('onApprove');
        return fetch('/api/pay/approve', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                RequestVerificationToken: getAntiForgeryToken(),
            },
            body: JSON.stringify({OrderID: data.orderID}),
        })
            .then(response => response.json())
            .then(r => {
                if (!r.isSuccess) {
                    s.uiCheckout.processing = false;
                    s.checkout.messages.push({
                        msg: r.errors,
                        msgType: ICheckoutMessageType.payment,
                    });
                    if (r.reset_payment === true) {
                        s.reset_payment = true;
                        // todo reset paypal advanced
                    }

                    if (r.new_checkout_step > 0) {
                        s.moveStep(r.new_checkout_step);
                        s.checkout.CheckoutType = ICheckoutType.normal;

                        if (r.errors === 'missing-shipping') {
                            s.checkout.force_normal_checkout = true;
                            s.checkout.missing_shipping_info = true;
                            modalOpen('modal-missing-shipping');
                        }
                    }
                } else {
                    OpenLink(r.custom_url);
                }
            })
            .catch(error => {
                s.checkout.messages = [];
                if (ppa_debug) {
                    console.log(error);
                }
                if (s.checkout.cstep === ICheckoutStep.payment) {
                    s.checkout.messages.push({
                        msg: 'Payment Error. Check the credit card number.',
                        msgType: ICheckoutMessageType.payment,
                    });
                }
            });
    }

    function onError(err: any) {
        // if(ppa_debug){ console.log(err); }
        //   s.checkout.messages.push({
        //     msg: `Payment Error. ${err}.`,
        //     msgType: ICheckoutMessageType.payment,
        // });
    }

    return (
        <PayPalScriptProvider options={initialOptions}>
            <PayPalCardFieldsProvider
                createOrder={createOrder}
                onApprove={onApprove}
                onError={onError}
            >
                <div className="card-info"></div>

                <PayPalCardFieldsForm className="ppa-cc" />
                <SubmitPayment
                    isPaying={isPaying}
                    setIsPaying={setIsPaying}
                    billingAddress={billingAddress}
                />
            </PayPalCardFieldsProvider>
            <div style={{fontWeight: 400, fontSize: 18, textAlign: 'center', display: 'none', marginTop: 12, marginBottom: 24}}>
                Our payment system is currently down, please come back later to pay. Use promo code <span style={{fontWeight: 700}}>FunTimes</span> to save 5% when you come back!
            </div>
            <div style={{fontStyle: 'italic', fontSize: 14, textAlign: 'right', marginTop: 2}}>
                Your card will be charged <span style={{fontWeight: 700, fontStyle: 'normal'}}>{currency(s.checkout.cart.pricing.total < 0 ? 0 : s.checkout.cart.pricing.total)}</span>
            </div>
            <div className="pay-by-card">
                <div style={{margin: '0 auto', textAlign: 'center'}}>
                    <div className="pay-by-card-line"></div>
                </div>
                <div className="pay-by-card-text">or</div>
            </div>

            <div
                id="applepay-outer"
                style={{margin: '0 auto', marginBottom: 12, textAlign: 'center', width: '100%'}}
            >
                {<div id="applepay-container"></div>}
            </div>

            <div style={{margin: '0 auto', textAlign: 'center', width: '100%'}}>
                <PayPalButtons
                    createOrder={createOrder}
                    onApprove={onApprove}
                    onError={onError}
                    // onClick={onClickWhat}
                    className={!s.uiCheckout.processing ? 'pay-center' : 'd-none'}
                    style={{tagline: false}}
                />
            </div>
        </PayPalScriptProvider>
    );
}
